import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { SaveButton } from "../../../components/Buttons";

export const Loss = () => {
    document.title = "Silinmə";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Məhsullar", value: "/products" },
        { name: "Silinmə", value: "/products/loss", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Silinmə</h2>
                    <p>
                        Anbarda məhsul sayını azaltmaq üçün nəzərdə tutulub. Yeni silinmə sənədi ilə seçilmiş məhsulun sayını azalda bilərsiniz. Açılmış
                        pəncərədə axtarış xanasından lazım olan məhsulu seçib sənədə əlavə etmək lazımdır. Daha sonra silinməli olan sayı qeyd edib
                        <SaveButton /> düyməsini sıxmaqla məhsul sayını azaltmış oluruq.
                    </p>
                    <img src="/images/products/documents/loss.gif" alt="Silinmə" />
                </article>
            </div>
        </div>
    );
};
